import { UserWidget } from 'features/auth';
import React, { memo } from 'react';

import { StyledLogo, TenantLogo, TopHat, UserLogoContainer } from './Header.styled';

interface HeaderProps {
    className?: string;
    logoUrl?: string;
    withLogo?: boolean;
    withUserWidget?: boolean;
}

const Header = ({ className, logoUrl, withLogo, withUserWidget }: HeaderProps) => {
    return (
        <TopHat className={ className }>
            <UserLogoContainer>
                { logoUrl && <TenantLogo src={ logoUrl } /> }
            </UserLogoContainer>

            { withLogo &&
                <a title="Globus.ai"
                    href="http://globus.ai"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <StyledLogo />
                </a>
            }

            { withUserWidget && <UserWidget /> }
        </TopHat>
    );
};

export default memo(Header);
